import { DataTableFilter, FilterType } from 'generated/resources/datatable.graphql'
import { FinanceFinancialDocumentFilter } from 'generated/resources/graphql'

import { Filter } from 'modules/core/components/DataTable/types'
import i18n from 'modules/core/lib/i18n'

import { InvoiceFilters } from 'modules/finance/components/Invoices/DataTableWrapper/types'

const isValidDateRange = (
  filter?: Filter<[string, string]>
): filter is Filter<[string, string]> => {
  return Boolean(
    filter?.value &&
    Array.isArray(filter.value) &&
    filter.value.length === 2 &&
    filter.value[0] &&
    filter.value[1]
  )
}

export const dateFilter = (
  onFilterChange: (filters: InvoiceFilters) => void,
  fromDate?: Date,
  toDate?: Date
): DataTableFilter<FinanceFinancialDocumentFilter> => {
  const onUpdateDateFilter = (filter?: Filter<[string, string]>) => {
    if (!isValidDateRange(filter)) {
      onFilterChange({ fromDate: undefined, toDate: undefined })
      return
    }

    const filterValue = filter.value
    if (Array.isArray(filterValue) && filterValue.length === 2) {
      onFilterChange({
        fromDate: new Date(filterValue[0]),
        toDate: new Date(filterValue[1]),
      })
    }
  }

  return {
    identifier: 'date',
    title: i18n.t('finance.invoices.list.fields.date'),
    path: 'documentDate',
    type: FilterType.Date,
    default: Boolean(fromDate && toDate),
    onUpdateValue: onUpdateDateFilter,
    categories: [
      {
        kind: 'DatePicker',
        operation: 'between',
        value:
          fromDate && toDate
            ? [fromDate.toISOString().substring(0, 10), toDate.toISOString().substring(0, 10)]
            : undefined,
      },
    ],
  }
}

export const dueDateFilter = (
  onFilterChange: (filters: InvoiceFilters) => void,
  fromDueDate?: Date,
  toDueDate?: Date
): DataTableFilter<FinanceFinancialDocumentFilter> => {
  const onUpdateDueDateFilter = (filter?: Filter<[string, string]>) => {
    if (!isValidDateRange(filter)) {
      onFilterChange({ fromDueDate: undefined, toDueDate: undefined })
      return
    }

    const filterValue = filter.value
    if (Array.isArray(filterValue) && filterValue.length === 2) {
      onFilterChange({
        fromDueDate: new Date(filterValue[0]),
        toDueDate: new Date(filterValue[1]),
      })
    }
  }

  return {
    identifier: 'due_date',
    title: i18n.t('finance.invoices.list.fields.due_date'),
    path: 'dueDate',
    onUpdateValue: onUpdateDueDateFilter,
    default: Boolean(fromDueDate && toDueDate),
    type: FilterType.Date,
    categories: [
      {
        kind: 'DatePicker',
        operation: 'between',
        value:
          fromDueDate && toDueDate
            ? [fromDueDate.toISOString().substring(0, 10), toDueDate.toISOString().substring(0, 10)]
            : undefined,
      },
    ],
  }
}
